import loadPdf from "./loadPdf";

export const readPdfMixins = {

    data() {
        return {
            all_page : 0,
            now_page : 1,
            tryError: 0,
            query: "",
            max_page_width : document.body.clientWidth > 650 ? 650 :  document.body.clientWidth,
            scale : 1,
            page_height : 1000,
            page_show_version: "v1",
            pdf_error_number: 0, //错误次数
        }
    },

    computed: {

        getScaleCss() {
            return `transform:scale(${this.scale});transformOrigin:0 0; `
        },
        getImageMaxWidth() {
          return `width:${this.max_page_width}px;`
        },
        getPdfBoxStyle() {
            return `width:${this.max_page_width}px;height:100%;`
        }
    },
    mounted() {
        document.addEventListener('scroll',e => {
            this.handleScroll(e)
        })

        this.scale =this.max_page_width / 650
    },
    methods: {
        /**
         * 监听鼠标滚动
         */
        handleScroll(e) {

            let scrollTop = document.documentElement.scrollTop ||
                document.body.scrollTop ||
                document.querySelector('.pdf-box').scrollTop;


            // let docHeight = document.querySelector('.pdf-box').scrollHeight;
            // console.log(docHeight)
            if (this.page_height !== 1000) {
                let mx = this.page_height / 3
                let page = Math.ceil((scrollTop + mx) / this.page_height);

                page = page < 1 ? 1 : page;

                this.now_page = page > this.all_page ? this.all_page : page ;
            }
        },
        /**
         * 图片加载成功
         * @param e
         */
        imgLoadingSuccess(e) {
            let zoom = this.max_page_width / e.naturalWidth;
            this.$set(this.pages[e.el.getAttribute('page-id')], 'page_width', e.naturalWidth * zoom)
            this.$set(this.pages[e.el.getAttribute('page-id')], 'page_height', e.naturalHeight * zoom)


            e.el.style.height = (e.naturalHeight * zoom) + 'px';
            e.el.className = 'pdf-box-in read-pdf-box-image'
            e.el.style.animationName = 'loadingPdf';
            e.el.parentElement.className = e.el.parentElement.className + " loading-success"

            this.page_height = e.naturalHeight  * zoom
        },

        /**
         * 页面加载成功
         * @param e
         */
        updatePageSize(e) {

            if (!e.width)
                return;
            setTimeout(() => {
                this.$set(this.pages[e.page], 'width', e.width);
                this.$set(this.pages[e.page], 'height', e.height);
                this.$set(this.pages[e.page], 'img_width', e.img_width);


                if (e.page === 0) {
                    this.seal_width = (e.width > this.max_page_width ? this.max_page_width : e.width) * 0.204;
                    this.seal_width_personal = (e.width > this.max_page_width ? this.max_page_width : e.width) * 0.12;
                    this.page_width = e.width
                }

            }, 200)
        },

        /**
         * 使用v2
         * @param pdf_url
         * @param successFun
         * @param json
         */
        useV2(pdf_url, successFun, json) {

            this.api.hideLoading()
            this.page_show_version = "v2"
            loadPdf.load(pdf_url, this.max_page_width, pages => {
                this.pages = pages
                this.all_page = pages.length
                successFun(json)
            }, res => {
                this.imgLoadingSuccess(res)
            })
        },

        /**
         * 读取成功
         * @param json
         * @param url
         * @param data
         * @param successFun
         * @returns {void|number|*}
         */
        readSuccess(json, url, data, successFun) {
            switch (json.code) {
                case 200 :
                    let doc = json.data.doc

                    //如果指定v2
                    if (this.page_show_version === 'v2' && doc.status_pdf === 1)
                        return this.useV2(doc.signed_file.file_url, successFun, json)

                    //如果图片未转换成功
                    if (doc.status_pdf === 1 && doc.status_png !== 1) {
                        if (this.pdf_error_number < 1) {
                            //再次尝试
                            return setTimeout(() => {
                                this.pdf_error_number += 1
                                this.read(url, data, successFun, json)
                            }, 3000)
                        }
                        // 如果支持pdf.js 且pdf转换成功， 其他转换失败 强制解析版本为v2
                        return this.useV2(doc.signed_file.file_url, successFun)
                    }

                    //如果pdf没有成功
                    if (doc.status_pdf !== 1) {
                        this.api.hideLoading()
                        return this.api.alert("该文档不支持该操作，请更换其他文档或重新")
                    }

                    //输出成功
                    this.api.hideLoading()

                    this.all_page = json.data.pages.length
                    successFun(json)
                    break;
                case  103 :
                    this.api.hideLoading()
                    break;
                default :
                    this.api.hideLoading()
                    this.api.alert(json.msg)
                    break;
            }
        },

        /**
         * 读取数据
         */
        readPdf(url, data, successFun) {

            let defaultData = {
                screenWidth: this.max_page_width
            }
            this.api.loading()
            this.api.post(
                url,
                {...data, ...defaultData},
                json => {

                    if (json.code !== 200 && this.tryError < 3) {
                        this.tryError += 1
                        return setTimeout(() => {
                            this.read(url, data, successFun)
                        }, 2000)
                    }
                    //数据读取成功
                    this.readSuccess(json, url, data, successFun)

                },
                error => {
                    this.api.hideLoading()
                    this.api.alert("网络异常，请重试")
                })
        }
    }
}
